import { render, staticRenderFns } from "./Agreements.vue?vue&type=template&id=c674e93e&"
import script from "./Agreements.vue?vue&type=script&lang=ts&"
export * from "./Agreements.vue?vue&type=script&lang=ts&"
import style0 from "./Agreements.vue?vue&type=style&index=0&id=c674e93e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports